'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = typographicArrows;
function typographicArrows(input) {
  return input.replace(/<->/gim, '↔').replace(/<=>/gim, '⇔').replace(/<-/gim, '←').replace(/->/gim, '→').replace(/<=/gim, '⇐').replace(/=>/gim, '⇒');
}
module.exports = exports['default'];
